// extracted by mini-css-extract-plugin
export default {"container":"promo_container__Rh0qg","promoContainer":"promo_promoContainer__l0TFc"};